import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const bulkSendApi = createApi({
  reducerPath: "bulkSendApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    bulkSendSMS: build.mutation({
      query: (body) => ({ url: "/bulk-send/sms", method: "POST", body }),
    }),
    bulkSendEmail: build.mutation({
      query: (body) => ({ url: "/bulk-send/email", method: "POST", body }),
    }),
    getMergeFields: build.query({
      query: () => ({ url: "/bulk-send/merge-fields" }),
      transformResponse: (res) => res.data || [],
    }),
  }),
});

export const {
  useBulkSendSMSMutation,
  useBulkSendEmailMutation,
  useGetMergeFieldsQuery,
} = bulkSendApi;
